import footer from './Footer'

const selfFooter = {
  install: Vue => {
    Vue.component('myFooter', footer)
  }
}

export default selfFooter



// WEBPACK FOOTER //
// ./src/components/footer/index.js